/* bt-motion — scroll reveal + count-up. Additive; does nothing if elements are missing. */
(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.bt-section .bt-container > *, .bt-article-card, .bt-trust__item, .bt-topic, .bt-expert-card, .bt-guide-card, .bt-test-card';
  function markReveal(root){
    var els = (root || document).querySelectorAll(SEL);
    els.forEach(function(el){
      if (el.classList.contains('bt-reveal') || el.closest('.bt-hero-section')) return; // hero stays instant (LCP)
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) return; // already on screen at load: no animation
      el.classList.add('bt-reveal');
      var n = (el.parentNode.__btIdx = (el.parentNode.__btIdx || 0) + 1);
      el.style.setProperty('--bt-delay', Math.min(n - 1, 6) * 70 + 'ms');
    });
  }
  var revealIO = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function countUp(el){
    var raw = el.textContent.trim();
    var m = raw.match(/^([^0-9]*)([0-9][0-9.,]*)(.*)$/); if (!m) return;
    var prefix = m[1], num = m[2], suffix = m[3];
    var sep = num.indexOf('.') > -1 && num.indexOf(',') === -1 && /\.\d{3}(\D|$)/.test(num) ? '.' : (num.indexOf(',') > -1 && /,\d{3}(\D|$)/.test(num) ? ',' : '');
    var target = parseFloat(num.replace(/[.,]/g, function(c){ return c === sep ? '' : '.'; }));
    if (isNaN(target)) return;
    var decimals = sep === '' && /[.,]\d{1,2}$/.test(num) ? num.length - num.search(/[.,]\d{1,2}$/) - 1 : 0;
    var start = null, dur = 1400;
    function fmt(v){
      var s = v.toFixed(decimals);
      if (sep) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return prefix + s + suffix;
    }
    function step(ts){
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1); p = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * p);
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }
  var countIO = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ countUp(e.target); countIO.unobserve(e.target); } });
  }, { threshold: 0.5 });

  function init(root){
    markReveal(root);
    (root || document).querySelectorAll('.bt-reveal:not(.is-in)').forEach(function(el){ revealIO.observe(el); });
    (root || document).querySelectorAll('[data-bt-count]:not([data-bt-counted])').forEach(function(el){ el.setAttribute('data-bt-counted','1'); countIO.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); }); else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
